let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("XreJj")).then(() => parcelRequire('hb5zJ'));